"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShowCategoriesToJSON = exports.ShowCategoriesFromJSONTyped = exports.ShowCategoriesFromJSON = exports.instanceOfShowCategories = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the ShowCategories interface.
 */
function instanceOfShowCategories(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfShowCategories = instanceOfShowCategories;
function ShowCategoriesFromJSON(json) {
    return ShowCategoriesFromJSONTyped(json, false);
}
exports.ShowCategoriesFromJSON = ShowCategoriesFromJSON;
function ShowCategoriesFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !(0, runtime_1.exists)(json, 'id') ? undefined : json['id'],
        'parentId': !(0, runtime_1.exists)(json, 'parent_id') ? undefined : json['parent_id'],
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
    };
}
exports.ShowCategoriesFromJSONTyped = ShowCategoriesFromJSONTyped;
function ShowCategoriesToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'parent_id': value.parentId,
        'name': value.name,
    };
}
exports.ShowCategoriesToJSON = ShowCategoriesToJSON;
